import { View } from '@clearkit/icons';
import { CKBox } from 'clearkit';

import { HomeBannerHeader, HomeBannerHeaderProps } from './HomeBannerHeader';

export const HomeBannerConnectCRM = ({ ...rest }: HomeBannerHeaderProps) => (
  <HomeBannerHeader {...rest}>
    <HomeBannerHeader.Left>
      <CKBox className="p-2">
        <View className="fill-gradient-br-x" />
      </CKBox>
    </HomeBannerHeader.Left>
    <HomeBannerHeader.Message>
      Connect your CRM to see how Clearbit can transform your data.{' '}
    </HomeBannerHeader.Message>
  </HomeBannerHeader>
);
